package com.rainbowclubs.rainbow.di

import org.koin.core.context.startKoin
import org.koin.core.context.stopKoin
import org.koin.core.module.Module

fun initKoin() {
    stopKoin()
    startKoin {
        modules(commonModule, platformModule)
    }
}

expect val platformModule: Module